import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import { getGraphViewAuditTrackerList_action } from "../../../../actions/admin_module_action/preSetupTracker_action/graphView_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  vendorActionId,
  serviceTypeId,
  stallActionId,
  stallTypeActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
  Title,
  Tooltip,
  LineElement,
  PointElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Line } from "react-chartjs-2";
ChartJS.register(
  LineElement,
  PointElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
  Title,
  Tooltip,
  ChartDataLabels
);

const styles = {
  width: "100%",
};

class GraphView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorId: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      halls: [],
      grid: [],
      graph1Obj: {},
      graph2Obj: {},
      graph3Obj: {},
      graph4Obj: {},
      stallTypeId: '',
      stallTypeList: [],
      VendorList: [],
      zoneId: '',
      VendorList: [],
    };

    this.getVendorAuditTrackerList = this.getVendorAuditTrackerList.bind(this);
    this.pollingTimer = null;
    // Criteria of the last executed search, replayed by the background refresh so it
    // can't pick up filter edits the user hasn't hit Search on yet
    this.lastQueryParams = null;
  }

  componentDidMount() {
    this.getFillList(hallActionId, "", "", "", "", "");
    this.getFillList(serviceTypeId, "", "", "", "", "");
    this.getFillList(stallTypeActionId, "", "", "", "", "");
    this.getFillList(vendorActionId, "", "", "", "", "");
    this.getVendorAuditTrackerList();
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  // Refresh the charts every 15s in the background (no page reload, no loader flicker)
  startPolling() {
    this.stopPolling();
    this.pollingTimer = setInterval(() => {
      if (document.hidden) {
        return;
      }
      this.getVendorAuditTrackerList(true);
    }, 15000);
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }

          if (actionID === stallTypeActionId) {
            this.setState({ stallTypeList: data.data });
          }

          if (actionID === vendorActionId) {
            this.setState({ VendorList: data.data });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // isSilent = background poll: keep the loader hidden, replay the last search and don't
  // toast transient errors
  async getVendorAuditTrackerList(isSilent = false) {
    const params =
      isSilent && this.lastQueryParams
        ? this.lastQueryParams
        : {
          zoneId: this.state.zoneId,
          ExhibitorName: this.state.ExhibitorName,
          VendorId: this.state.VendorId,
          StatusID: this.state.StatusID,
          hallId: this.state.hallId,
          ExhRegNo: this.state.ExhRegNo,
          serviceId: this.state.serviceId,
          stallTypeId: this.state.stallTypeId,
          zoneId: this.state.zoneId,
        };
    this.lastQueryParams = params;

    if (!isSilent) this.setState({ isLoading: true });

    try {
      const data = await this.props.getGraphViewAuditTrackerList_action(
        params.hallId,
        params.VendorId,
        params.serviceId,
        params.stallTypeId,
        params.zoneId,
      );

      // Handle API error
      if (data.error === 1) {
        if (!isSilent) toastError(data.error);
        return;
      }
      const list1 = this.graph1DataConvert(data.data[0], data.data[2]);
      const list2 = this.graph2DataConvert(data.data[1]);
      const list3 = this.graph3DataConvert(data.data[2]);
      const list4 = this.graph4DataConvert(data.data[3]);
      if (!isSilent) console.log("list2", list2);

      const nextGraphs = {
        graph1Obj: list1,
        graph2Obj: list2,
        graph3Obj: list3,
        graph4Obj: list4,
      };
      // Handing the charts a new data object makes them re-animate, so on a background
      // refresh only push it when the numbers actually changed
      if (isSilent && this.isSameGraphData(nextGraphs)) {
        return;
      }
      this.setState(nextGraphs);
    } catch (err) {
      console.error("Error in getVendorAuditTrackerList:", err);
      if (!isSilent) {
        toastError(
          "Something went wrong while fetching Hall Manager Work Updation list."
        );
      }
    } finally {
      if (!isSilent) this.setState({ isLoading: false });
    }
  }

  isSameGraphData(nextGraphs) {
    const { graph1Obj, graph2Obj, graph3Obj, graph4Obj } = this.state;
    return (
      JSON.stringify({ graph1Obj, graph2Obj, graph3Obj, graph4Obj }) ===
      JSON.stringify(nextGraphs)
    );
  }

  // graph1DataConvert(inputData) {
  //   const labels = inputData.map(x => `${x.HallName}`);
  //   return {
  //     labels,
  //     datasets: [
  //       {
  //         label: "Stall Possession",
  //         data: inputData.map((x) => x.StallPossessionCount),
  //         backgroundColor: "#058773"
  //       },
  //       {
  //         label: "NDC Issued",
  //         data: inputData.map((x) => x.NDCIssuedCount),
  //         backgroundColor: "#ffc05b"
  //       },
  //       {
  //         label: "Possession Pending",
  //         data: inputData.map((x) => x.PossessionPendingCount),
  //         backgroundColor: "#9fd9d0"
  //       },
  //       {
  //         label: "No Show",
  //         data: inputData.map((x) => x.NoShowCount),
  //         backgroundColor: "#ef4444"
  //       },
  //     ],
  //   };
  // }

  graph1DataConvert(inputData, arr = []) {
    const labels = inputData.map(x => x.HallName);

    return {
      labels,

      datasets: [
        // =========================
        // BAR DATA
        // =========================
        {
          type: "bar",
          label: "Stall Possession",
          data: inputData.map(x => x.StallPossessionCount),
          backgroundColor: "#058773",
          order: 2
        },
        {
          type: "bar",
          label: "NDC Issued",
          data: inputData.map(x => x.NDCIssuedCount),
          backgroundColor: "#ffc05b",
          order: 2
        },
        {
          type: "bar",
          label: "Possession Pending",
          data: inputData.map(x => x.PossessionPendingCount),
          backgroundColor: "#9fd9d0",
          order: 2
        },
        {
          type: "bar",
          label: "No Show",
          data: inputData.map(x => x.NoShowCount),
          backgroundColor: "#ef4444",
          order: 2
        },

        // =========================
        // PLANNED
        // =========================
        {
          type: "line",
          label: "Planned",
          data: arr.map(item => item.PlannedCount),

          borderDash: [5, 5],
          borderColor: "#058773",
          borderWidth: 2,

          tension: 0.3,
          fill: false,

          pointRadius: 5,
          pointHoverRadius: 7,
          pointBackgroundColor: "#058773",

          order: 1
        },

        // =========================
        // ACTUAL
        // =========================
        {
          type: "line",
          label: "Actual",
          data: arr.map(item => item.ActualCount),

          borderColor: "#3cbba7",
          borderWidth: 2,

          tension: 0.3,
          fill: false,

          pointRadius: 5,
          pointHoverRadius: 7,
          pointBackgroundColor: "#3cbba7",

          order: 1,

          // Show DATE only once
          datalabels: {
            display: true,

            formatter: (value, context) => {
              const item = arr[context.dataIndex];

              if (!item || !item.Dates) {
                return "";
              }

              const d = new Date(item.Dates);

              return d.toLocaleDateString("en-GB").split("/").join("-");
            },

            align: "top",
            anchor: "center",

            font: {
              size: 10,
              weight: "bold"
            },

            color: "#FFFFFF"
          }
        }
      ]
    };
  }

  graph2DataConvert(halls) {
    return {
      labels: halls.map(x => `${x.HallName}`),
      datasets: [
        {
          label: "Count of Completed",
          data: halls.map((x) => x.Completed),
          backgroundColor: "#058773",
        },
        {
          label: "Count of Pending",
          data: halls.map((x) => x.TotalStallCount - x.Completed),
          // data: halls.map((x) => x.PendingCount),
          backgroundColor: "#9fd9d0",
        },
        {
          label: "Count of Pending",
          data: halls.map((x) => x.InProgress),
          backgroundColor: "#ffc05b",
        },

      ],
    };
  }

  graph3DataConvert(arr) {
    const labels = arr.map(item => {
      const d = new Date(item.Dates);
      return d.toLocaleDateString("en-GB").split("/").join("-");
    });

    const planned = arr.map(item => item.PlannedCount);
    const actual = arr.map(item => item.ActualCount);

    return {
      labels,
      datasets: [
        {
          label: "Planned",
          data: planned,
          borderDash: [5, 5],
          borderColor: "#058773",
          borderWidth: 2,
          tension: 0.3,
          fill: false,
          pointRadius: 4,
          pointBackgroundColor: "#058773",
        },
        {
          label: "Actual",
          data: actual,
          borderColor: "#3cbba7",
          borderWidth: 2,
          tension: 0.3,
          fill: false,
          pointRadius: 4,
          pointBackgroundColor: "#3cbba7",
        },
      ],
    };
  }

  graph4DataConvert(apiResponse) {
    return {
      labels: apiResponse.map(item => item.Vendor.trim()),
      datasets: [
        {
          label: "Count of Completed",
          data: apiResponse.map(item => item.CompletedCount),
          backgroundColor: "#058773",
        },
        {
          label: "Count of Pending",
          data: apiResponse.map(item => item.PendingCount),
          backgroundColor: "#9fd9d0",
        },
      ],
    };
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorId: "",
        stallTypeId: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
      },
      () => this.getVendorAuditTrackerList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  graph1() {
    const { graph1Obj } = this.state;
    console.log("graph1Obj---->", graph1Obj)
    // const data = {
    //     labels: [
    //         'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'H7', 'H8', 'H9', 'H10', 'H11', 'H12', 'H13', 'H14', 'H15'
    //     ],
    //     datasets: [
    //         {
    //             label: 'Taken',
    //             data: [80, 90, 100, 70, 85, 90, 95, 100, 110, 120, 100, 105, 90, 85, 95],
    //             backgroundColor: '#59a14f',
    //         },
    //         {
    //             label: 'Pending',
    //             data: [20, 30, 25, 15, 20, 25, 30, 20, 40, 30, 20, 25, 20, 15, 20],
    //             backgroundColor: '#edc948',
    //         },
    //         {
    //             label: 'Not-issued',
    //             data: [10, 15, 20, 10, 10, 15, 10, 15, 20, 20, 10, 15, 10, 10, 10],
    //             backgroundColor: '#bab0ab',
    //         },
    //         {
    //             label: 'Not-issued (Due)',
    //             data: [10, 15, 10, 15, 10, 10, 15, 10, 15, 10, 10, 10, 10, 10, 10],
    //             backgroundColor: '#e15759',
    //         },
    //     ],
    // };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          // text: `Stall Allotment Status (as of ${moment().format('MMMM YYYY')})`,
          font: { size: 16, weight: "bold" },
        },
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 20,
            font: { size: 13, weight: "bold" },
          },
        },
        datalabels: {
          color: "white",
          anchor: "center",
          align: "center",
          font: {
            weight: "bold",
            size: 12,
          },
          formatter: (value) => (value > 0 ? value : ""),
        },
      },
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            text: "Number of Halls",
            font: { weight: "bold" },
          },
          grid: { display: false },
        },
        y: {
          stacked: true,
          beginAtZero: true,
          title: {
            display: true,
            text: "Number of Stalls",
            font: { weight: "bold" },
          },
          ticks: {
            stepSize: 20,
          },
        },
      },
    };
    if (graph1Obj && Object.keys(graph1Obj).length > 0) {
      return (
        <div
          style={{
            width: "100%",
            height: "500px",
            // maxWidth: "900px",
            // margin: "0 auto",
          }}
        >
          <Bar data={graph1Obj} options={options} plugins={[ChartDataLabels]} />
        </div>
      );
    }

    return null;
  }

  graph2() {
    const { graph2Obj } = this.state;
    const data = {
      labels: [
        "H1",
        "H2",
        "H3",
        "H4",
        "H5",
        "H6",
        "H7",
        "H8",
        "H9",
        "H10",
        "H11",
        "H12",
        "H13",
        "H14",
        "H15",
      ],
      datasets: [
        {
          label: "Count of Completed",
          data: [60, 55, 70, 50, 45, 60, 65, 80, 90, 70, 50, 60, 55, 50, 45],
          backgroundColor: "#4e79a7",
        },
        {
          label: "Count of Pending",
          data: [40, 50, 45, 30, 35, 40, 50, 60, 70, 55, 40, 45, 30, 35, 40],
          backgroundColor: "#f28e2b",
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false, // ✅ allow height to stretch
      plugins: {
        legend: { position: "bottom" },
        datalabels: {
          color: "white",
          anchor: "center",
          align: "center",
          font: { weight: "bold" },
          formatter: (value) => (value > 0 ? value : ""),
        },
      },
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            text: "Number of Halls",
            font: { weight: "bold" },
          },
        },
        y: {
          stacked: true,
          title: {
            display: true,
            text: "Number of Stalls",
            font: { weight: "bold" },
          },
          ticks: {
            stepSize: 20,
          },
        },
      },
    };

    if (graph2Obj && Object.keys(graph2Obj).length > 0) {
      return (
        <div
          style={{
            width: "100%",
            height: "500px",
            // maxWidth: "900px",
            // margin: "0 auto",
          }}
        >
          <Bar data={graph2Obj} options={options} plugins={[ChartDataLabels]} />
        </div>
      );
    }
  }

  graph3() {
    const { graph3Obj } = this.state
    console.log("graph3Obj---------->", graph3Obj);
    // const data = {
    //   labels: [
    //     "26-11-2026",
    //     "27-11-2026",
    //     "28-11-2026",
    //     "29-11-2026",
    //     "30-11-2026",
    //     "01-12-2026",
    //   ],
    //   datasets: [
    //     {
    //       label: "Planned",
    //       data: [100, 200, 300, 500, 700, 850],
    //       borderDash: [5, 5],
    //       borderColor: "#4e79a7",
    //       borderWidth: 2,
    //       tension: 0.3,
    //       fill: false,
    //       pointRadius: 4,
    //       pointBackgroundColor: "#4e79a7",
    //     },
    //     {
    //       label: "Actual",
    //       data: [80, 150, 250, 400, 650, 800],
    //       borderColor: "#f28e2b",
    //       borderWidth: 2,
    //       tension: 0.3,
    //       fill: false,
    //       pointRadius: 4,
    //       pointBackgroundColor: "#f28e2b",
    //     },
    //   ],
    // };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: "bottom" },
        tooltip: { enabled: true },
        datalabels: { display: false },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: "Event Date",
            font: { weight: "bold" },
          },
        },
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: "Number of Stalls",
            font: { weight: "bold" },
          },
          ticks: {
            stepSize: 5,   // 👈 this controls 5,10,15,20
          },
          // max: 20,       // 👈 optional: if you want to force maximum to 20
        },
      },
    };


    if (graph3Obj && Object.keys(graph3Obj).length > 0) {
      return (
        // ✅ Increased height container
        <div
          style={{
            width: "100%",
            height: "500px",
            // maxWidth: "900px",
            // margin: "0 auto",
          }}
        >
          <Line data={graph3Obj} options={options} />
        </div>
      );
    }
  }

  graph4() {
    const { graph4Obj } = this.state;
    if (!graph4Obj || !graph4Obj.labels?.length) return null;

    const labelCount = graph4Obj.labels.length;

    // 🔹 Horizontal scroll only when many labels
    const enableScroll = labelCount > 6;
    const minChartWidth = enableScroll ? labelCount * 80 : "100%";

    // 🔹 Fixed slim bars (no fat bars)
    const barWidth = labelCount <= 4 ? 18 : 22;

    const data = {
      ...graph4Obj,
      datasets: graph4Obj.datasets.map(ds => ({
        ...ds,
        barThickness: barWidth,
        maxBarThickness: barWidth,
      })),
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: { position: "bottom" },
        datalabels: {
          color: "white",
          anchor: "center",
          align: "center",
          font: { weight: "bold", size: 11 },
          formatter: v => (v > 0 ? v : ""),
        },
      },

      scales: {
        x: {
          stacked: true,

          offset: true,              // ✅ bar centered in grid box
          categoryPercentage: 0.6,   // ✅ smaller grid width
          barPercentage: 0.5,

          grid: {
            drawBorder: false,
            offset: true,            // ✅ grid box centered
          },

          ticks: {
            autoSkip: false,
            align: "center",
            maxRotation: 30,
            minRotation: 30,
          },

          title: {
            display: true,
            text: "Vendors",
            font: { weight: "bold" },
          },
        },

        y: {
          stacked: true,
          beginAtZero: true,         // ✅ ORIGINAL height behavior
          ticks: { stepSize: 1 },

          grid: {
            drawBorder: false,
          },

          title: {
            display: true,
            text: "Number of Stalls",
            font: { weight: "bold" },
          },
        },
      },
    };

    return (
      <div style={{ width: "100%", overflowX: enableScroll ? "auto" : "hidden" }}>
        {/* 🔹 Keep original height */}
        <div style={{ height: "400px", minWidth: minChartWidth }}>
          <Bar
            data={data}
            options={options}
            plugins={[ChartDataLabels]}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      isLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorId,
      RoleID,
      stallTypeId,
      stallTypeList,
      VendorList
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {RoleID == 16 && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className="app-content with-dr-container com-height admin-top-space"
            style={{ marginLeft: 0 }}
          >
            <main id="main" class={RoleID == 16 ? "px-3" : "px-1"}>
              <section class="section" style={{ padding: 0 }}>
                <div class="row m-0">
                  <div class="px-0 py-2">
                    <div class="d-flex align-items-end w-100">
                      <div class="col-md-3">
                        <label class="ms-1">Hall</label>
                        <select
                          className="form-control"
                          id="roledb"
                          value={hallId}
                          onChange={(e) =>
                            this.setState({ hallId: e.target.value }, () => {
                              if (e.target.value != "") {
                                this.getFillList(
                                  HallZoneActionId,
                                  this.state.exhibitionID,
                                  e.target.value,
                                  "",
                                  "",
                                  "",
                                  false
                                );
                              } else {
                                this.setState({ zoneList: [] });
                              }
                            })
                          }
                        >
                          <option value={""}>Select</option>
                          {hallList.length > 0 &&
                            hallList.map((data) => (
                              <option key={data.HallId} value={data.HallId}>
                                {data.HallName}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="ms-1">Zone</label>
                        <select
                          className="form-control"
                          id="roledb"
                          value={zoneId}
                          onChange={(e) =>
                            this.setState({ zoneId: e.target.value })
                          }
                        >
                          <option value={""}>Select</option>
                          {zoneList.length > 0 &&
                            zoneList.map((data) => (
                              <option
                                key={data.HallZoneMappingID}
                                value={data.HallZoneMappingID}
                              >
                                {data.Zone}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="ms-1">Service Partner Company</label>
                        <select
                          className="form-control form-control-sm w-100"
                          id="roledb"
                          value={VendorId}
                          onChange={(e) =>
                            this.setState({ VendorId: e.target.value })
                          }
                        >
                          <option value={""}>Select</option>
                          {VendorList.length > 0 &&
                            VendorList.map((data) => (
                              <option
                                key={data.VendorID}
                                value={data.VendorID}
                              >
                                {data.CompanyName}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="ms-1">Services</label>
                        <select
                          className="form-control form-control-sm w-100"
                          id="roledb"
                          value={serviceId}
                          onChange={(e) =>
                            this.setState({ serviceId: e.target.value })
                          }
                        >
                          <option value={""}>Select</option>
                          {serviceList.length > 0 &&
                            serviceList.map((data) => (
                              <option
                                key={data.ServiceID}
                                value={data.ServiceID}
                              >
                                {data.Name}
                              </option>
                            ))}
                        </select>
                      </div>

                    </div>
                    <div className="d-flex align-items-end w-100">
                      <div class="col-md-3">
                        <label class="ms-1">Booth Type</label>
                        <select
                          className="form-control form-control-sm w-100"
                          id="roledb"
                          value={stallTypeId}
                          onChange={(e) =>
                            this.setState({ stallTypeId: e.target.value })
                          }
                        >
                          <option value={""}>Select</option>
                          {stallTypeList.length > 0 &&
                            stallTypeList.map((data) => (
                              <option
                                key={data.Code}
                                value={data.Code}
                              >
                                {data.Description}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div class="col-md-3 d-flex mt-3">
                        <div class="me-2">
                          <button
                            class="btn btn-aqua"
                            onClick={() => this.getVendorAuditTrackerList()}
                          >
                            Search
                          </button>
                        </div>

                        <div>
                          <button
                            class="btn btn-gray"
                            onClick={() => this.handleClear()}
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-12 mt-3">
                      {this.graph1() && <h6 className="text-center text-aqua">Stall Possession - Status Overview</h6>}
                      <div class="card shadow-md mb-2">{this.graph1()}</div>
                    </div>
                    <div className="col-12 mt-3">
                      {this.graph2() && <h6 className="text-center text-aqua">Stall Work - Progress Overview</h6>}
                      <div class="card shadow-md mb-2">{this.graph2()}</div>
                    </div>
                    {/* <div className="col-12 mt-3">
                      {this.graph3() && <h6 className="text-center text-aqua">Stall Target vs. Achievement</h6>}
                      <div class="card shadow-md mb-2">{this.graph3()}</div>
                    </div> */}
                    <div className="col-12 mt-3">
                      {this.graph4() && <h6 className="text-center text-aqua">Service Partner - Work Progress</h6>}
                      <div class="card shadow-md mb-2">{this.graph4()}</div>
                    </div>
                  </div>
                </div>
              </section>
            </main>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getGraphViewAuditTrackerList_action,
  })(GraphView)
);
